import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import './passwordReset.css';
import { Link } from "react-router-dom";

function PasswordReset () {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Correo de restablecimiento de contraseña enviado. Revisa tu correo.')
        } catch (error) {
            setMessage('Error enviando correo de restablecimiento de contraseña. Intentelo nuevamente.')
            console.error('Error sending password reset email:', error);
        }
    }

    return(
        <main className='login-main password-reset flex'>
        <section className='box-login flex'>
            <article className='login-title'>
                <h2>Restablecimiento de Contraseña</h2>
                <p>Ingresa tu correo</p>
            </article>
            <form onSubmit={handleSubmit} className='form-login flex'>
                <span className='input flex'>
                    <label htmlFor='email' className='label-email'>Correo electrónico</label>
                    <input type="email" id="email" name="email"  className='input-email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Ingresa correo electrónico' required/>
                </span>
                <button type="submit" className='button-login'><h3>Enviar</h3></button>
                <p className='message-password-reset'>{message}</p>
                <Link to='/login' className='link' >Volver a LogIn</Link>
            </form>
        </section>
    </main>
    )
};

export default PasswordReset;